export default {
    listagem: {
        titulo_pagina: 'Lista de Funciones',
        novo: 'Registrar Nueva Función',
        table: {
            empty: 'No se encontró ninguna función',
            nome: 'Nombre',
            url: 'URL',
            url_autenticacao: 'URL Auth',
            credencial: 'Credencial',
            classe_autenticacao: 'Clase de Autenticación',
            classe_cloud_function: 'Clase de Cloud Function',
            file_format: 'Formato de Archivo',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Registrar Nueva Función',
            editar: 'Editar Función'
        },
        fields: {
            nome: {
                label: 'Nombre',
                description: 'Nombre de la Función ex. TITAN Google'
            },
            url: {
                label: 'URL',
                description: 'ex: http://googlecloud.com/function'
            },
            url_autenticacao: {
                label: 'URL de autenticación',
                description: 'ex: http://googlecloud.com/auth'
            },
            classe_autenticacao: {
                label: 'Clase de autenticación',
                description: 'ex: HL7'
            },
            credencial: {
                label: 'Credencial',
                description: 'Credencial de Autenticación'
            },
            classe_montagem: {
                label: 'Clase de Ensamblaje',
                description: 'ex: HL7v3'
            },
            classe_cloud_function: {
                label: 'Clase de CloudFunction',
                description: 'ex: GoogleCloudFunctionHandler'
            },
            formato_arquivo: {
                label: 'Formato de Archivo',
                description: ''
            },
            credencial_incluida: {
                label: '¿La credencial está incluida en Analizador?',
                description: 'Esta opción está marcada cuando el usuario y la contraseña están incluidos en el archivo enviado a soporte.'
            },
            botao_salvar : 'Guardar Función'
        },
        create: {
            success: '¡Función creada con éxito!',
            error: '¡Error al crear la función!'
        },
        update: {
            success: '¡Función editada con éxito!',
            error: '¡Error en la función de edición!'
        }
    }
}
